// extracted by mini-css-extract-plugin
export default {"pillar":"ContentfulIntroPillars-module__pillar--vKCrh"};